import axios from './rest-axios';

const postfromqywx = (begin, end) => axios.post(`/manage/cw_zcdj/getfromqywx`, {begin, end});
const getAll = (data) => axios.get(`/manage/cw_zcdj`, {params: data});
const getwfl = (month) => axios.get(`/manage/cw_zcdj/wfl`, {params: {month}});
const getyfl = (month, md) => axios.get(`/manage/cw_zcdj/yfl`, {params: {month, md}});

const postadd = (ids, coa_id, md) => axios.post(`/manage/cw_zcdj/add`, {ids, coa_id, md});
const postremove = (ids) => axios.post(`/manage/cw_zcdj/remove`, {ids});
const getcwzcdjstat = (month, coa_id) => axios.get(`/manage/cw_zcdj/stat`, {params: {month, coa_id}});
const getcwzcdjstatyue = (year, coa_id) => axios.get(`/manage/cw_zcdj/statyue`, {params: {year, coa_id}});
const postmuti = (list) => axios.post(`/manage/cw_zcdj/postmuti`, {list});
const updatefkrq = (ids, fkrq) => axios.post(`/manage/cw_zcdj/updatefkrq`, {ids, fkrq});
const deletezcdj = (id) => axios.delete(`/manage/cw_zcdj/${id}`);

export {
    postfromqywx,
    getwfl,
    getyfl,
    postadd,
    postremove,
    getcwzcdjstat,
    getcwzcdjstatyue,
    postmuti,
    getAll,
    updatefkrq,
    deletezcdj,
};